import React, { FC, PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { RouterBrowserHistory, useHistory } from '@packages/router-dom/useHistory';

/**
 * @deprecated
 */
// @ts-ignore
export let browserHistory: RouterBrowserHistory = {};

const Router: FC<PropsWithChildren> = ({ children }) => {
	browserHistory = useHistory();

	return <>{children}</>;
};

const RouterProvider: FC<PropsWithChildren> = ({ children }) => {
	return (
		<BrowserRouter>
			<Router>{children}</Router>
		</BrowserRouter>
	);
};

export { RouterProvider };
